import React from 'react';
import { FileIconBase } from './_base';
const PdfFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#5B6CD8", label: "PDF" })));
export default PdfFileIcon;
